// Auto-generated from contact.html. Verbatim redesign import. Do NOT edit.
export const SCRIPT = `
(function(){
  var form=document.getElementById('contactForm');
  if(!form||form.dataset.wired==='1') return; form.dataset.wired='1';
  var select=document.getElementById('inquirySelect');
  var errBox=document.getElementById('formError');
  var submitBtn=document.getElementById('submitBtn');
  var submitLabel=document.getElementById('submitLabel');
  var submitArrow=document.getElementById('submitArrow');
  var successState=document.getElementById('successState');
  var resetBtn=document.getElementById('resetBtn');
  var successRef=document.getElementById('successRef');
  var inFlight=false;

  // prefill from ?inquiry=
  try{ var p=new URLSearchParams(window.location.search); var inq=(p.get('inquiry')||'').toLowerCase();
    var alias={general:'',asset_manager:'institution',issuer:'institution',bank:'custodian',developer:'builder',press:'media'};
    if(alias.hasOwnProperty(inq)) inq=alias[inq];
    var opts=Array.prototype.map.call(select.options,function(o){return o.value;});
    if(inq && opts.indexOf(inq)!==-1) select.value=inq;
  }catch(e){}

  function showError(msg){ errBox.textContent=msg; errBox.classList.remove('hidden'); }
  function clearError(){ errBox.classList.add('hidden'); errBox.textContent=''; }

  form.addEventListener('submit', async function(e){
    e.preventDefault(); clearError();
    if(inFlight) return;
    if(!select.value){ select.setCustomValidity('Please choose who you are contacting as.'); } else { select.setCustomValidity(''); }
    if(!form.checkValidity()){ form.reportValidity(); return; }
    inFlight=true;
    var data={ name:form.name.value, email:form.email.value, company:form.company.value, role:form.role.value, inquiry_type:select.value, message:form.message.value, website:((form.website&&form.website.value)||'') };
    submitBtn.disabled=true; submitArrow.classList.add('hidden'); submitLabel.textContent='Sending';
    try{
      var res=await fetch('/api/contact',{ method:'POST', headers:{'Content-Type':'application/json'}, body:JSON.stringify(data) });
      if(!res.ok){ var d={}; try{ d=await res.json(); }catch(_){} throw new Error((d&&d.detail)||'Submission failed'); }
      var out={}; try{ out=await res.json(); }catch(_){}
      if(successRef) successRef.textContent=(out&&out.message_id)||'';
      form.classList.add('hidden'); successState.classList.remove('hidden');
    }catch(err){
      showError((err&&err.message)||'Submission failed');
      submitBtn.disabled=false; submitArrow.classList.remove('hidden'); submitLabel.textContent='Request a conversation';
    }finally{ inFlight=false; }
  });

  resetBtn.addEventListener('click', function(){
    form.reset(); select.value=''; clearError();
    successState.classList.add('hidden'); form.classList.remove('hidden');
    submitBtn.disabled=false; submitArrow.classList.remove('hidden'); submitLabel.textContent='Request a conversation';
  });
})();
`;
